export default "__VITE_ASSET__71c20bcf__"